//import packages from node modules
import React, { useCallback, useEffect,useContext } from 'react'
import PropTypes from 'prop-types'
import {useSelector,useDispatch} from 'react-redux'
import {updateConfig,addItemToCart} from '../../app/action'
import { ConnectorContext, UPDATE_BILLING_CYCLE } from './index'
import PRODUCT from '../../utilities/api/product'

//import utility functions
import {
  convertConfigOptionsToObject
} from '../../utilities/function/common'

import {
  getDataFromSuccessResponse
} from '../../utilities/function/apiResponse'

import {
  getPriceByBillingCycleName
} from '../../utilities/function/billingCycle'

import {getAttributes} from '../../utilities/function/configuration'

//main component
let ConnectorFunctions = (props) => {
  const { router } = props
  const {dispatch} = useContext(ConnectorContext)
  const appDispatch = useDispatch()
  const {
    configurations
  } = useSelector(state=>({
    configurations: state.app.configurations
  }))
  const rebuildFunction = useCallback(()=>{
    const {history} = router
    const collections = {
      updateConfig: (config,cid)=>{
        updateConfig(configurations,cid,config,appDispatch)
      },
      goTo: (path)=>{
        history.push(path)
      },
      updateBillingCycle: (cycle) =>{
        dispatch({
          type: UPDATE_BILLING_CYCLE,
          productType: 'webHosting',
          cycle
        })
      },
     addItemToCart: (id,cycleName,callback=null) =>{
        PRODUCT.getProduct([id]).then(successResponse=>{
          const selectedProduct = getDataFromSuccessResponse(successResponse) && getDataFromSuccessResponse(successResponse).length?getDataFromSuccessResponse(successResponse)[0]: null
          if(selectedProduct && getAttributes(selectedProduct)){
            const productConfig = {
              selectedProduct,
            }
            const {price} = getAttributes(selectedProduct)
            const billingCycle = getPriceByBillingCycleName(price,cycleName)
            if(billingCycle){
              productConfig.billing_cycle_id = billingCycle.billing_cycle_id
            }
            updateConfig(configurations,id,productConfig,appDispatch)
            const updatedConfigurations = localStorage.configurations && JSON.parse(localStorage.configurations)?JSON.parse(localStorage.configurations):{}
            addItemToCart(productConfig, appDispatch, history, updatedConfigurations,null,callback)
          }
        })
     },
      convertConfigOptionsToObject: (pid,config)=>{
        const productConfig = configurations[pid]
        return convertConfigOptionsToObject(config,productConfig)
      }
    }
    window.app_collections = collections
  },[appDispatch,configurations,router,dispatch])
  useEffect(()=>{
    rebuildFunction()
  },[rebuildFunction])
  return (
    <></>
  )
}
ConnectorFunctions.propTypes = {
  router: PropTypes.object
}

export default ConnectorFunctions